import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = ["data-target", "aria-controls", "aria-expanded"];
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", null, null, -1);
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", null, null, -1);
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("button", {
    class: "navbar-toggler",
    type: "button",
    "data-toggle": "collapse",
    "data-target": $props.target,
    "aria-controls": $props.target,
    "aria-expanded": $props.toggled,
    "aria-label": "Toggle navigation"
  }, [_renderSlot(_ctx.$slots, "default", {}, () => [_hoisted_2, _hoisted_3])], 8, _hoisted_1);
}